export default "__VITE_ASSET__BXzlDhVx__"